import { all, takeLatest } from 'redux-saga/effects';
import * as ACTIONS from '../../actions/actionTypes';
import asyncHorariosDisponiveis from './asyncHorariosDisponiveis';
export default function* root() {
    yield all([
        takeLatest(ACTIONS.REQUEST_HORARIOS_DISPONIVEIS, asyncHorariosDisponiveis),
    ])
}